import { useNotification } from '@/shared/hooks/useNotification';
import { defineComponent, computed, reactive } from '@vue/composition-api';
import CommonLayout from './common-layout.component.vue';
import UnauthenticatedLayout from './unauthenticated-layout.component.vue';
import { Fragment } from 'vue-fragment';
import { noAuthPaths } from '@/constants/path';

export default defineComponent({
  components: {
    'common-layout': CommonLayout,
    'unauthenticated-layout': UnauthenticatedLayout,
    Fragment,
  },
  setup(_, ctx) {
    const { notification } = useNotification();

    const state = reactive({
      isAuthPage: false,
    });

    const isAuthPage = computed(() => {
      const path = ctx.root.$route.path;

      return [...noAuthPaths, '/'].includes(path) ? false : true;
    });

    return {
      state,
      notification,
      isAuthPage,
      messages: computed(() => [notification.value.message].flat()),
    };
  },
});
